import { Component, ViewEncapsulation, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'ups-card-content',
    template: require('./ups-card-content.component.html'),
    encapsulation: ViewEncapsulation.None
})


export class UpsCardContentComponent implements AfterViewInit {

    @Input() color: string = '';
    @Input() numberCardsFlex: number = 0;
    @Output() private eventClick: EventEmitter<string> = new EventEmitter();

    constructor() { }

    ngAfterViewInit() {
    }

    evClick() {
        this.eventClick.emit('Click');
    }


    public getHeaderClass() {
        let colorHeadClass: string;
        switch (this.color) {
            case 'ups-success':
                colorHeadClass = 'ups-cv_card_header ups-success';
                break;
            case 'ups-alert':
                colorHeadClass = 'ups-cv_card_header ups-alert';
                break;
            case 'ups-stopped':
                colorHeadClass = 'ups-cv_card_header ups-stopped';
                break;
            default:
                colorHeadClass = ''
                break;
        }
        return colorHeadClass;
    }

    public getIconClass() {
        let colorIconClass: string;
        switch (this.color) {
            case 'ups-success':
                colorIconClass = 'ups-cv_card_icon ups-success_icon';
                break;
            case 'ups-alert':
                colorIconClass = 'ups-cv_card_icon ups-alert_icon';
                break;
            case 'ups-stopped':
                colorIconClass = 'ups-cv_card_icon ups-stopped_icon';
                break;
            default:
                colorIconClass = ''
                break;
        }
        return colorIconClass;
    }

    public getNumberCardsFlex(): string {
        let flex: string;
        switch (this.numberCardsFlex) {
            case 1:
                //flex = 'col-xs-8 col-sm-6 col-md-4 col-lg-4';
                flex = 'col-xs-12 col-sm-12 col-md-4 col-lg-4';
                break;
            case 2:
                //flex = 'col-xs-6 col-sm-6 col-md-6 col-lg-6';
                flex = 'col-xs-12 col-sm-12 col-md-6 col-lg-6';
                break;
            case 3:
                //flex = 'col-xs-4 col-sm-4 col-md-4 col-lg-4';
                flex = 'col-xs-12 col-sm-12 col-md-4 col-lg-4';
                break;
            case 4:
                //flex = 'col-xs-6 col-sm-6 col-md-6 col-lg-3;
                flex = 'col-xs-12 col-sm-12 col-md-3 col-lg-3';
                break;
            default:
                //flex = 'col-xs-6 col-sm-6 col-md-6 col-lg-3';
                flex = 'col-xs-12 col-sm-12 col-md-3 col-lg-3';
                break;
        }
        return flex;
    }
}